module.exports = __webpack_public_path__ + "static/media/single-dark.fd0fea35.svg";